import makeStyles from '@material-ui/core/styles/makeStyles';
import customPaperStyles from '../styles/customPaper.styles';

const usePaperStyles = makeStyles(customPaperStyles);

export {customPaperStyles, usePaperStyles};